export enum InternalMessageType {
  AddToCart = 'addToCart',
  AddToCartResponse = 'addToCartResponse',
  CloseDialog = 'closeDialog',
  GalleryReady = 'galleryReady',
  GalleryVisibility = 'galleryVisibility',
  OpenDialog = 'openDialog',
  PrefetchDialog = 'prefetchDialog',
  Resize = 'resize',
}
